// If you are adding a term to the ActionSubjectId glossary,
// please add a member of the Data team to your PR

export const ActionSubjectId = {
  atlassianAccountOnboardingBannerSnoozeButton:
    'atlassianAccountOnboardingBannerSnoozeButton',
  atlassianAccountCompleteOnboardingSuccessButton:
    'atlassianAccountCompleteOnboardingSuccessButton',
  atlassianOnboardingHelpDocButton: 'atlassianOnboardingHelpDocButton',
  atlassianOnboardingMixedUseAccountButton:
    'atlassianOnboardingMixedUseAccountButton',
  atlassianAccountOnboardingForWorkButton:
    'atlassianAccountOnboardingForWorkButton',
  atlassianOnboardingGoToSettingsToRemoveEmailButton:
    'atlassianOnboardingGoToSettingsToRemoveEmailButton',
  atlassianOnboardingLoginWithAtlassianButton:
    'atlassianOnboardingLoginWithAtlassianButton',
  atlassianOnboardingMenuBackButton: 'atlassianOnboardingMenuBackButton',
  atlassianAccountOnboardingNotWorkButton:
    'atlassianAccountOnboardingNotWorkButton',
  atlassianAccountOnboardingOverlay: 'atlassianAccountOnboardingOverlay',
  atlassianAccountOnboardingOverlayCloseButton:
    'atlassianAccountOnboardingOverlayCloseButton',
  atlassianOnboardingPersonalAccountButton:
    'atlassianOnboardingPersonalAccountButton',
  atlassianOnboardingRemoveEmailButton: 'atlassianOnboardingRemoveEmailButton',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  attachmentGetPowerEnableButton: 'attachmentGetPowerEnableButton',
  attachmentGetPowerLearnMoreLink: 'attachmentGetPowerLearnMoreLink',
  avatarGravatarOptionButton: 'avatarGravatarOptionButton',
  avatarNoneOptionButton: 'avatarNoneOptionButton',
  avatarPreviouslyUploadedOptionButton: 'avatarPreviouslyUploadedOptionButton',
  bcUpgradePill: 'bcUpgradePill',
  bcUpgradePrompt: 'bcUpgradePrompt',
  boardDirectoryCloseButton: 'boardDirectoryCloseButton',
  boardMenuDrawerCloseButton: 'boardMenuDrawerCloseButton',
  boardMenuPowerUpLink: 'boardMenuPowerUpLink',
  boardMenuToggleLink: 'boardMenuToggleLink',
  boardSearchResultLink: 'boardSearchResultLink',
  cancelButton: 'cancelButton',
  cardMapExternalLink: 'cardMapExternalLink',
  cardMapEditLocationButton: 'cardMapEditLocationButton',
  cardMapLocationButton: 'cardMapLocationButton',
  cardMapLocation: 'cardMapLocation',
  cardSearchResultLink: 'cardSearchResultLink',
  categoryNavLink: 'categoryNavLink',
  changeEmailButton: 'changeEmailButton',
  changeOrgDrawerNavigationItem: 'changeOrgDrawerNavigationItem',
  closeBoardDrawerNavigationItem: 'closeBoardDrawerNavigationItem',
  colorBoardBackground: 'colorBoardBackground',
  convertToBoardDrawerNavigationItem: 'convertToBoardDrawerNavigationItem',
  commentPermsDrawerNavigationItem: 'commentPermsDrawerNavigationItem',
  cookieConsentDrawerNavigationItem: 'cookieConsentDrawerNavigationItem',
  copyBoardDrawerNavigationItem: 'copyBoardDrawerNavigationItem',
  copyLinkButton: 'copyLinkButton',
  createCardButton: 'createCardButton',
  createCardFromTemplateButton: 'createCardFromTemplateButton',
  customBoardBackground: 'customBoardBackground',
  customPowerUpLearnMoreHeaderLink: 'customPowerUpLearnMoreHeaderLink',
  downloadLink: 'downloadLink',
  emptyPowerUpSlotButton: 'emptyPowerUpSlotButton',
  exportButton: 'exportButton',
  fullNameProfileLink: 'fullNameProfileLink',
  hideVotesBoardPref: 'hideVotesBoardPref',
  homeTab: 'homeTab',
  integrationsNavigationMenuLink: 'integrationsNavigationMenuLink',
  invitationsPermsDrawerNavigationItem: 'invitationsPermsDrawerNavigationItem',
  inviteToBoardDisableLink: 'inviteToBoardDisableLink',
  inviteToBoardLink: 'inviteToBoardLink',
  inviteToBoardLinkCopyButton: 'inviteToBoardLinkCopyButton',
  learnMoreLink: 'learnMoreLink',
  leaveDrawerNavigationItem: 'leaveDrawerNavigationItem',
  linkCopyButton: 'linkCopyButton',
  linkCopyInput: 'linkCopyInput',
  makeTemplateFromBoardDrawerNavigationItem:
    'makeTemplateFromBoardDrawerNavigationItem',
  mapLocationPowerUpLink: 'mapLocationPowerUpLink',
  memberSearchResultLink: 'memberSearchResultLink',
  miniProfileAvatar: 'miniProfileAvatar',
  powerUpAddButton: 'powerUpAddButton',
  powerUpDirectoryDrawerNavigationItem: 'powerUpDirectoryDrawerNavigationItem',
  powerUpEditButton: 'powerUpEditButton',
  powerUpCard: 'powerUpCard',
  removeEmailButton: 'removeEmailButton',
  removeOrgDrawerNavigationItem: 'removeOrgDrawerNavigationItem',
  searchInlineDialog: 'searchInlineDialog',
  searchInput: 'searchInput',
  searchShortcut: 'searchShortcut',
  selfJoinDrawerNavigationItem: 'selfJoinDrawerNavigationItem',
  setAsPrimaryEmailButton: 'setAsPrimaryEmailButton',
  setUpAtlassianAccountAndRemoveEmailsButton:
    'setUpAtlassianAccountAndRemoveEmailsButton',
  showAllActivityButton: 'showAllActivityButton',
  showAllPowerUpsButton: 'showAllPowerUpsButton',
  showCommentsOnlyButton: 'showCommentsOnlyButton',
  showFewerPowerUpsButton: 'showFewerPowerUpsButton',
  startWithTemplateLink: 'startWithTemplateLink',
  teamSearchResultLink: 'teamSearchResultLink',
  templatePreview: 'templatePreview',
  templateTile: 'templateTile',
  unknown: 'unknown', // This represents a generic error case and should be used sparingly!
  upgradeToBCButton: 'upgradeToBCButton',
  useTemplateButton: 'useTemplateButton',
  viewTemplateButton: 'viewTemplateButton',
  votingPermsDrawerNavigationItem: 'votingPermsDrawerNavigationItem',
  votingBoardPref: 'votingBoardPref',
  watchDrawerNavigationItem: 'watchDrawerNavigationItem',
} as const;

export type ActionSubjectIdType = typeof ActionSubjectId[keyof typeof ActionSubjectId];

export const isValidActionSubjectId = (a: ActionSubjectIdType) => {
  const validSources = Object.values(ActionSubjectId);
  return validSources.includes(a);
};
